<template>
    <div class="row row-sm-column">
        <div class="col-9 col-sm-12 order-sm-5" v-if="!this.showErrorMessage">
            <div v-if="this.loading">Loading...</div>
            <div class="alert info" v-else-if="offers[storeDestiny].length < 1">
                <vs-icon icon="error"></vs-icon>
                No existen ofertas para mostrar
            </div>
            <div v-else>
                <div
                    :key="offer.id"
                    v-for="offer in $store.getters['Offer/offersList'](
                        storeDestiny
                    )"
                >
                    <div>
                        <slot name="delivery-list" :offer="offer">
                            <DeliveryListRow
                                @reload-published-offers="reloadPublishedOffers"
                                :filterType="filterType"
                                :offer="offer"
                                :market="market"
                                :admin="admin"
                            />
                        </slot>
                    </div>
                </div>
            </div>

            <WePagination
                v-if="paginationTotalPages > 1"
                :total="paginationTotalPages"
                v-model="pagination"
            />
        </div>

        <!-- Offline error -->
        <div v-if="this.showErrorMessage" class="col-9 col-sm-12 order-sm-last">
            <div class="alert info danger">
                <vs-icon icon="warning"></vs-icon>

                <b>
                    Ha ocurrido un error en la comunicación con nuestros
                    servidores.
                </b>
                <br />

                Por favor, intente los siguientes pasos:
                <ul class="error-list">
                    <li>Comprobar los cables de red, el módem y el router</li>
                    <li>Volver a conectarse a una red Wi-Fi</li>
                </ul>

                Si ya ha comprobado que tiene conexión a internet, intente
                refrescar esta página. <br />
                Si el problema persiste, consulte con soporte técnico.
            </div>
        </div>

        <div class="col-3 col-sm-12 order-sm-first">
            <DeliveryFilter
                @search="getOffers"
                ref="filtersComponent"
                :filterType="currentType"
                :filterSubtype="filterSubtype"
                :filter-by-state="showStateFilter"
                :market="market"
                :userCanSell="userCanSell"
            />
            <MarketRankingOrganization v-if="!hideRanking && !loading" class="hidden-mobile" />
        </div>
        <div v-if="!hideRanking && !loading" class="col-9 col-sm-12 order-sm-5 hidden-desktop">
            <MarketRankingOrganization />
        </div>
    </div>
</template>

<script>
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";
import { mapState, mapMutations } from "vuex";
import DeliveryListRow from "./DeliveryListRow.vue";
import WePagination from "../lib/WebExperto/components/WePagination.vue";
import MarketRankingOrganization from "./MarketRankingOrganization.vue";
import DeliveryFilter from "./DeliveryFilter.vue";

const listOffers = gql`
    query listOffers(
        $organizationId: Int
        $currentUserToken: String
        $type: String
        $subtype: String
        $states: [String!]
        $weekFrom: Int
        $weekTo: Int
        $filters: FilterInput
        $scope: String
        $page: Int
    ) {
        listOffers(
            organizationId: $organizationId
            currentUserToken: $currentUserToken
            type: $type
            subtype: $subtype
            states: $states
            weekFrom: $weekFrom
            weekTo: $weekTo
            filters: $filters
            scope: $scope
            page: $page
        ) {
            totalPages
            offers {
                agent {
                    user {
                        firstname
                        lastname
                    }
                    createdAt
                }
                alreadyPublishedInMuvin
                bestPrice
                cancelledAt
                acceptedAt
                week
                conflictResolution
                paymentMethod
                paymentDeadline
                deliveryAtDestination
                canOperate
                displayName
                displayLocation
                id
                isParticipant
                offerType
                pdfUrl
                dueAt
                kilometers
                publishedAt
                operationsCount
                organization {
                    city
                }
                quality {
                    performance
                    leanQuality
                    slaughterWeight
                    dorsalFat
                }
                negotiations {
                    state
                    senderId
                    pdfUrl
                    receiverId
                }
                part {
                    destination {
                        city
                        state
                        id
                        name
                        organization {
                            businessName
                        }
                    }
                    opener {
                        organizationId
                    }
                    origin {
                        id
                        city
                        state
                        name
                        organization {
                            businessName
                        }
                    }
                    destinationOrganization{
                        businessName
                    }
                }
                negotiableAttributes {
                    quantity
                    price
                    performance
                    leanQuality
                    securePayment {
                        lapse
                        lock
                        percentage
                    }
                    slaughterWeight
                    dorsalFat
                    deliveryAtDestination
                }
                category {
                    name
                }
                pendingOperations
                price
                quantity
                quantityLeft
                securePayment {
                    lapse
                    percentage
                    stage
                }
                state
                subtype
                description
                agroNacionPayment
            }
        }
    }
`;

const isHideRanking = gql`
  query {
    isHideRanking
  }
`

export default {
    name: "delivery-list",
    components: {
    DeliveryListRow,
    WePagination,
    MarketRankingOrganization,
    DeliveryFilter
},
    data() {
        return {
            showErrorMessage: false,
            loading: false,
            offerId: "",
            pagination: 1,
            totalPages: "",
            loadMarket: false,
            prueba: false,
            hideRanking: undefined,
        };
    },
    props: {
        showStateFilter: {
            type: Boolean,
            required: false,
            default: true,
        },
        filterSubtype: {
            type: Boolean,
            required: false,
            default: true,
        },
        filterType: {
            type: String,
            required: false,
            default: "activeOffers",
        },
        offersStates: {
            type: Array,
            required: true,
        },
        storeDestiny: {
            type: String,
            required: true,
            default: "publishedList",
        },
        autoload: {
            type: Boolean,
            required: false,
            default: false,
        },
        market: {
            type: Boolean,
            required: false,
            default: false,
        },
        negotiations: {
            type: Boolean,
            required: false,
            default: false,
        },
        operations: {
            type: Boolean,
            required: false,
            default: false,
        },
        admin: {
            type: Boolean,
            required: false,
            default: false,
        },
        userCanSell: {
            type: Boolean,
            required: false,
        },
    },
    computed: {
        ...mapState({
            offers: (state) => state.Offer.offersGroup,
            currentUser: (state) => state.User.currentUser,
        }),
        paginationTotalPages() {
            if (this.totalPages) {
                return this.totalPages;
            }
            return 0;
        },
        currentType() {
            if (this.admin) {
                return "adminOffers";
            }
            return this.filterType;
        },
    },
    watch: {
        pagination() {
            this.getOffers();
        },
        currentUser(newValue, oldValue) {
            if (
                !this.$store.getters["Offer/offersList"](this.storeDestiny)
                    .length
            ) {
                this.getOffers();
            } else if (this.autoload) {
                this.getOffers();
            }
        },
    },
    beforeMount() {
        if (this.$parent.selected) {
            if (this.currentUser.id) {
                this.getOffers();
            }
        } else if (this.autoload) {
            if (this.currentUser.id) {
                this.getOffers();
            }
        } else {
            this.getOffers();
        }
        this.isRankingHidden();
    },
    mounted() {
        if (this.currentUser) {
            if (this.market) {
                this.loadMarket = true;
                this.getOffers();
            }
        }
    },
    beforeUnmount() {
        this.showErrorMessage = false;
        this.loading = true;
    },
    methods: {
        ...mapMutations("Offer", ["setOffersByDestiny"]),
        getOffers() {
            if (this.loading && this.currentUser) {
                return;
            }
            if (!this.loadMarket && this.market) {
                return;
            }
            var variables = {
                page: this.pagination,
                states: this.offersStates,
                organizationId: this.currentUser.organizationId,
                currentUserToken: localStorage.getItem("USER_TOKEN"),
            };
            if (this.$refs.filtersComponent) {
                var weekFrom = this.$refs.filtersComponent.weekFrom;
                var weekTo = this.$refs.filtersComponent.weekTo;
                if (weekFrom) {
                    var WY = weekFrom.split("-");
                    weekFrom = Number(`${WY[1]}${WY[0]}`);
                }
                if (weekTo) {
                    let WY = weekTo.split("-");
                    weekTo = Number(`${WY[1]}${WY[0]}`);
                }
                Object.assign(variables, {
                    weekFrom: weekFrom,
                    weekTo: weekTo,
                    filters: this.$refs.filtersComponent.filters,
                });
                if (this.$refs.filtersComponent.filterByState) {
                    Object.assign(variables, {
                        states: this.$refs.filtersComponent.states,
                    });
                }
                if (this.$refs.filtersComponent.securePaymentFilter) {
                    if (this.$refs.filtersComponent.securePaymentStage) {
                        variables.filters.securePayment = {
                            stage: this.$refs.filtersComponent
                                .securePaymentStage,
                        };
                    } else {
                        variables.filters.securePayment = { stage: "all" };
                    }
                }
            }
            if (this.market) {
                Object.assign(variables, { scope: "market" });
            }
            if (this.negotiations) {
                Object.assign(variables, { scope: "negotiations" });
            }
            if (this.operations) {
                Object.assign(variables, { scope: "operations" });
            }
            if (this.offers !== []) {
                this.loading = true;
                axios
                    .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                        params: {
                            query: print(listOffers),
                            variables: variables,
                        },
                    })

                    .then((res) => {
                        this.showErrorMessage = false;
                        if (!res.data.errors) {
                            this.setOffersByDestiny({
                                destiny: this.storeDestiny,
                                offers: res.data.data.listOffers.offers,
                            });
                            this.totalPages =
                                res.data.data.listOffers.totalPages;
                        } else {
                            console.log(res.data.errors);
                        }
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.showErrorMessage = true;
                        // Espero 1 segundos y vuelvo a intentar
                        setTimeout(() => {}, 2000);
                    });
            }
        },
        reloadPublishedOffers() {
          this.getOffers();
        },
        isRankingHidden() {
          axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
            query: print(isHideRanking)
          }}).then(res => {
            this.hideRanking = res.data.data.isHideRanking;
          }).catch((err) => {
            console.log(err)
          })
        },
    },
};
//      REVEER
//       if (this.offers !== []) {
//         this.loading = true;
//         const retryInterval = setInterval(async () => {
//           try {
//             const res = await axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, {
//               params: {
//                 query: print(listOffers),
//                 variables: variables
//               }
//             });
//             if (!res.data.errors) {
//               this.setOffersByDestiny({
//                 destiny: this.storeDestiny,
//                 offers: res.data.data.listOffers.offers
//               });
//               this.totalPages = res.data.data.listOffers.totalPages;
//               this.loading = false;
//               debugger
//               clearInterval(retryInterval);
//             } else {
//               this.retry--;
//               if (this.retry === 0) {
//                 this.loading = false;
//                 clearInterval(retryInterval);
//               }
//             }
//           } catch (error){
//             if (error) {
//                this.retry--;
//                 if (this.retry === 0) {
//                   this.loading = false;
//                   clearInterval(retryInterval);
//               }
//             }
//           }
//         }, 2000);
//         this.retry = 8;
//       }
//     },
//     reloadPublishedOffers() {
//       this.getOffers();
//     }
//   }
// };
</script>
<style scoped>
.error-list {
    padding-left: 50px;
}

.alert {
    margin-top: 0px !important;
}
</style>